import { FC } from "react"
import { styled, Typography, TypographyTypeMap } from "@mui/material"
import { OverridableComponent } from "@mui/material/OverridableComponent"
import { StyledInput } from "../inputs/InputComponent"
import { SelectComponentBase } from "../inputs/SelectComponent"

export type ParagraphProps = {
  children?: string | JSX.Element | JSX.Element[]
  className?: string
  style?: React.CSSProperties
}

export const Paragraph: FC<ParagraphProps> = ({
  children,
  className,
  style
}) => {
  return (
    <StyledTypography className={className} style={style}>
      {children}
    </StyledTypography>
  )
}

const generateIndentStyles = (maxLevels = 20) => {
  const styles: Record<string, React.CSSProperties> = {}
  for (let i = 1; i <= maxLevels; i++) {
    styles[`&.ql-indent-${i}, & .ql-indent-${i}`] = {
      // 2.625 to match authoring indent style
      paddingLeft: `${i * 2.625}em`
    }
  }
  return styles
}

const generateAlignmentStyles = () => {
  return {
    "&.ql-align-left, & .ql-align-left": {
      textAlign: "left"
    },
    "&.ql-align-center, & .ql-align-center": {
      textAlign: "center"
    },
    "&.ql-align-right, & .ql-align-right": {
      textAlign: "right"
    },
    "&.ql-align-justify, & .ql-align-justify": {
      textAlign: "justify"
    }
  }
}

const StyledTypography = styled<
  OverridableComponent<TypographyTypeMap<{}, "p">>
>(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  whiteSpace: "pre-wrap",
  textWrap: "wrap",
  overflowWrap: "break-word",

  [theme.breakpoints.down("mobile")]: {
    marginBottom: theme.spacing(3)
  },

  [`:has(${StyledInput}), :has(${SelectComponentBase})`]: {
    lineHeight: "2.5rem",

    [theme.breakpoints.down("mobile")]: {
      lineHeight: "2.125rem"
    }
  },
  ...generateIndentStyles(),
  ...generateAlignmentStyles()
}))
